<template>
  <sl-page>
    <div class='page-filter'>
      <Row :gutter="12">
        <Col span="6" :lg="6" :md="12" :sm="12" :xs="24" class="margin-bottom">
        <Cascader :data="areaData" v-model="params.districtCodes" placeholder="请选择省市区" change-on-select></Cascader>
        </Col>
        <Col span="6" :lg="6" :md="12" :sm="12" :xs="24" class="margin-bottom">
        <DatePicker v-model="params.daterange" type="daterange" @on-change="daterangeChange" placement="bottom-end" placeholder="请选择日期" style="width: 100%;" clearable></DatePicker>
        </Col>
        <Col span="7" :lg="7" :md="12" :sm="12" :xs="24" class="page-action">
        <div>
          <Button type="primary" icon="ios-search" @click="queryInit()">搜索</Button>
          <Button @click="reset()">清空</Button>
        </div>
        </Col>
      </Row>
    </div>
    <div>
      <chart ref="chartNumber"></chart>
      <chart ref="chartPrice"></chart>
      <div>
        <span style="font-weight: 800;font-size: 18px;color: rgba(0, 0, 0, 0.75);margin-left: 10px;">已接订单热力图</span>
      </div>
      <sl-amap style="height: 800px;">
        <sl-amap-heatmap ref="heatmap"></sl-amap-heatmap>
      </sl-amap>
    </div>
  </sl-page>
</template>
<script>
import { areaData } from '../../../util/area.js'

import dics from './dics'
import { mapState } from 'vuex'
import chart from './chart'
import { getPositionByCode } from '@/components/vue-sl/city-select'
import { wgs2gcj, gcj2wgs } from '@/util/map/proj'
export default {
  components: { chart },
  data() {
    return {
      ...dics,
      areaData: areaData,
      data: [],
      params: {
        districtCodes: [],
        daterange: []
      },
      page: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      loading: false,
      selection: [],
      dateArr: null,

    }
  },
  computed: {
    removeDisable() {
      return this.selection.length == 0
    },
  },
  created() {
    this.def = JSON.parse(JSON.stringify(this.params))
    this.queryInit()
  },
  mounted() {
    this.initChart()
  },

  methods: {
    initChart() {
      window.onresize = () => {
        this.$refs.chartNumber.resize()
        this.$refs.chartPrice.resize()
      }
    },
    queryInit() {
      this.page = {
        pageNum: 1,
        pageSize: 10,
        total: 0
      }
      this.queryStats()
    },
    getSearch() {
      // 搜索值过滤
      let search = this.$utils.filterSearch(this.params)
      // 省市区
      if (search.districtCodes && search.districtCodes.length > 0) {
        let i = search.districtCodes.length - 1
        search.districtCode = search.districtCodes[i]
        delete search.districtCodes
      }
      // 日期
      if (search.daterange && search.daterange[0] && search.daterange[1]) {
        search.startDate = this.$utils.date(search.daterange[0])
        search.endDate = this.$utils.date(search.daterange[1])
        delete search.daterange
      } else {
        delete search.daterange
      }
      return search
    },


    create() {

    },

    reset() {
      this.dateArr = null
      this.$utils.fill(this.params, this.def)
      this.queryStats()
    },

    handleUpdate() {
      this.modalVisible = false
    },

    handleChange(pageNum, pageSize) {
      if (this.page.pageNum != pageNum || this.page.pageSize != pageSize) {
        this.page.pageNum = pageNum
        this.page.pageSize = pageSize
      }
    },

    handleSelect(selection) {
      this.selection = selection.map(i => i.id)
    },

    onUpdatelist() {},
    queryStats() {
      // 搜索值过滤
      let search = this.getSearch()
      let data = search
      this.$request.assTicketQueryStats(data).then(resp => {
        // 金额统计
        let amountStats = resp.data.amountStats || []
        this.chartPriceSetData(amountStats)
        // 区域统计
        let districtStats = resp.data.districtStats || []
        this.heatmapSetData(districtStats)
        // 提交单量统计
        let numStats = resp.data.numStats || []
        this.chartNumberSetData(numStats)
      })
    },
    chartNumberSetData(numStats) {
      let numData = []
      let numCompleteData = []
      let xAxisData = []
      numStats.forEach(item => {
        let num = item.num || 0
        let numComplete = item.numComplete || 0
        numData.push(num)
        numCompleteData.push(numComplete)
        xAxisData.push(item.statsDate)
      })
      let commonBarSeries = [{
        name: '提交订单',
        type: 'bar',
        barMaxWidth: 30,
        data: numData
      }, {
        name: '完成订单',
        type: 'bar',
        barMaxWidth: 30,
        data: numCompleteData
      }]

      this.$refs.chartNumber.setData(commonBarSeries, xAxisData, '订单数量统计图')
    },
    chartPriceSetData(amountStats) {
      let zeroFeeData = []
      let payAmountData = []
      let xAxisData = []
      amountStats.forEach(item => {
        let zeroFee = parseFloat((item.amount - item.payAmount).toFixed(2))
        let payAmount = item.payAmount || 0
        zeroFeeData.push(zeroFee)
        payAmountData.push(payAmount)
        xAxisData.push(item.statsDate)
      })
      let stackBarSeries = [{
        name: '三包',
        type: 'bar',
        stack: '堆',
        barMaxWidth: 30,
        data: zeroFeeData
      }, {
        name: '自费',
        type: 'bar',
        stack: '堆',
        barMaxWidth: 30,
        data: payAmountData
      }]
      this.$refs.chartPrice.setData(stackBarSeries, xAxisData, '订单金额统计图')
    },
    heatmapSetData(districtStats) {
      let points = []
      districtStats.forEach(item => {
        let len = item.districtCode.length
        let districtCode = len === 2 ? item.districtCode + '0000' : (len === 4 ? item.districtCode + '00' : item.districtCode)
        let point = this.code2lonlat(districtCode)
        point = wgs2gcj(...point)
        if (item.districtCode && point) {
          let one = { "lng": point[0], "lat": point[1], "count": item.num }
          points.push(one)
        }
      })
      this.$refs.heatmap.setData(points, '已接订单热力图')
    },
    code2lonlat(districtCode) {
      let point = getPositionByCode(districtCode)
      return point
    },
    daterangeChange(arr) {
      console.log('daterangeChange------', arr)
    }
  }
}

</script>
